module.exports = __webpack_public_path__ + "static/media/QuakerValleyByLaws.68aafdc1.pdf";